
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import CrudField from '../fields/CrudField.vue';
import Util from '../../assets/utils/Util';
import HttpRequest from '../../assets/utils/HttpRequest';
import SnackbarUtils from '../../assets/utils/SnackbarUtils';
import RowPopUp from '../popups/RowPopUp.vue';
import GridToolbar from '../grids/GridToolbar.vue';
import ConfirmationDialog from '../popups/ConfirmationDialog.vue';

@Component({
  name: 'CrudGrid',
  components: {
    CrudField,
    RowPopUp,
    GridToolbar,
    ConfirmationDialog,
  },
})
class CrudGrid extends Vue {
  // #region [ PROPS ]
  @Prop({ default: ():any => [] })
  private readonly actions: any[];

  @Prop({ default: (): any  => [], required: false })
  private readonly buttons: any[];

  @Prop({ required: true })
  private readonly columns: any[];

  @Prop({ default: (): any => {} })
  private readonly defaultRow: any;

  @Prop({ default: () => {return {}} })
  private readonly filters: any;

  @Prop({ })
  private readonly footerRow: any;

  @Prop({ default: false })
  private readonly gridEditable : boolean;

  @Prop({ default: false })
  private readonly hideDefaultFooter: boolean;

  @Prop({ default: false })
  private readonly loading: boolean;

  @Prop({ default: 'Carregando itens...' })
  private readonly loadingText: string;

  @Prop({ default: '' })
  private readonly name: string;

  @Prop({ default: 'Nenhum item encontrado.' })
  private readonly noDataText: string;

  @Prop({ default: undefined })
  private readonly onEnterAction: any;

  @Prop({ default: undefined })
  private readonly onEscAction: any;

  @Prop({ default: (): any => [] })
  private readonly PopUpButtons: any[];

  @Prop({ default: false })
  private readonly readonly: boolean;

  @Prop({ default: false })
  private readonly reloadOnCreation: boolean;

  @Prop({ default: '' })
  private readonly route: string;

  @Prop({ default: undefined })
  private readonly rowPopUpMaxWidth: string | number;

  @Prop({ default: ():any => [] })
  private readonly rows: any[];

  @Prop({ default: null })
  private readonly showActionsFunc: Function;

  @Prop({ default: true })
  private readonly showToolbar: boolean;

  @Prop({ default: (): any => [] })
  private readonly toolbarActions: any[];

  @Prop({ default: (): any => [] })
  private readonly toolbarDefaultActionsOnClick: [];

  @Prop({ default: (): any => [] })
  private readonly toolbarDetailsActions: [];

  @Prop({ default: (): any => [] })
  private readonly toolbarNotShowWichDefaultActions: [];

  @Prop({ default: false })
  private readonly toolbarShowDefaultActions: boolean;

  @Prop({ default: 0 })
  private readonly triggerAddPopup: number;

  @Prop({ default: 0 })
  private readonly triggerForceUpdate: number;

  @Prop({ default: 0 })
  private readonly triggerReload: number;

  @Prop({ default: false })
  private readonly showAuditFields: boolean;
  // #endregion

  // #region [ DATA ]
  private tableRows: any = [];
  private tableColumns: any = [];
  private searchValue: string = '';

  private continuar: boolean = false;
  private showDialog: boolean = false;
  private messageDialog: string = "Deseja excluir registro?";


  private currentRow: any = {};

  private tableLoading = false;

  private backup: any = [];
  private nextId = 0;

  private showRowPopUp: boolean = false;


  private defaultActions = {
    edit: {
      name: 'Editar',
      value: 'edit',
      icon: 'mdi-pencil',
      action: this.edit,
      mode: 'view',
    },
    delete: {
      name: 'Excluir',
      value: 'delete',
      icon: 'mdi-delete',
      action: this.askDelete,
      mode: 'view',
    },
    view: {
      name: 'Visualizar',
      value: 'view',
      icon: 'mdi-eye',
      action: this.viewMode,
      mode: 'view',
    },
    save: {
      name: 'Salvar',
      value: 'save',
      icon: 'mdi-content-save',
      action: this.save,
      mode: 'edit',
    },
    cancel: {
      name: 'Cancelar',
      value: 'cancel',
      icon: 'mdi-cancel',
      action: this.cancel,
      mode: 'edit',
    },
  };

  private defaultToolbarActions = {
    add: {
      icon: 'mdi-plus-circle',
      name: 'Adicionar',
      label: 'Adicionar',
      value: 'add',
      onClick: this.addRow
    },
    addPopUp: {
      icon: 'mdi-plus-circle',
      name: 'Adicionar',
      label: 'Adicionar',
      value: 'add',
      onClick: this.addRowPopUp
    },
    reload: {
      icon: 'mdi-refresh',
      name: 'Recarregar',
      label: 'Atualizar',
      value: 'reload',
      onClick: this.reload
    },
  };

  private defaultToobarButtons = {
    adicionar: {
      name: 'Adicionar',
      value: 'adicionar',
      //icon: 'Adicionar',
      onClick: this.addRowPopUp,
      mode: 'view',
      label: 'Adicionar'
    }
  }

  private confirmation = {
    headlineMessage: 'Deseja realmente excluir o registro?',
    icon: 'mdi-comment-question',
    showIcon: true,
    dialog: true,
    aditional: {
      confirmActions: {
        actions: [
          { name: 'Sim', event: 'confirmacaoAlmoco', color: 'blue' },
          { name: 'Não', event: 'dialogConfirmed', color: 'blue' },
        ],
        display: false,
        displayOk: false,
      },
    },
  };

  private triggerUpdateFields = 0;
  // #endregion

  // #region [ COMPUTED ]
  private get isReadOnly(): boolean {
    const readOnly =
      this.readonly === true ||
      (this.readonly as any) === 'true' ||
      (this.readonly as any) === '';

    return readOnly;
  }

  private get tableActions() : any[] {
    const actions = this.actions.map((action: any)  => {
      const isString = typeof action === 'string';
      let newAction;

      if (isString) {
        newAction = (this.defaultActions as any)[action];

        if (!newAction) {
          console.error(`A action "${action}" não existe!`);
        }
      } else {
        newAction = action;
      }

      return newAction;
    });

    return actions;
  }

  private get dataRows() {
    const rows = this.tableRows.filter((row: any) => !row.__footer);

    return rows;
  }

  private get tableToolbarAction() {
    const actions = this.toolbarActions.map(action => {
      const tbAction = typeof action === 'string' ?
        (this.defaultToolbarActions as any)[action] :
        action;

      return tbAction;
    });

    return actions;
  }

  private get tableToolbarButtons() {
    const actions = this.buttons.map(action => {
      const tbAction = typeof action === 'string' ?
        (this.defaultToobarButtons as any)[action] :
        action;

      return tbAction;
    });

    return actions;
  }

  private get isLoading(): boolean {
    return this.loading || this.tableLoading;
  }
  /* #endregion */

  // #region [ WATCHERS ]
  @Watch('columns')
  private columnsOnChange() {
    this.createTableColumns();
  }

  @Watch('footerRow', {deep: true})
  private footerRowOnChange() {
    this.insertFooterRow();
  }

  @Watch('rows')
  private rowsOnChange() {
    this.tableRows = Util.deepCopy(this.rows);
    this.createTableRows();
  }

  @Watch('showRowPopUp')
  private showRowPopUpOnChange() {
    this.triggerUpdateFields++;
  }

  @Watch('triggerAddPopup')
  private triggerAddPopupOnChange() {
    this.addRowPopUp();
  }

  @Watch('triggerForceUpdate')
  private triggerForceUpdateOnChange() {
    this.$forceUpdate();
  }

  @Watch('triggerReload')
  private triggerReloadOnChange() {
    this.showRowPopUp = false;
    this.reload();
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private async created() {
    this.createTableColumns();

    if (this.reloadOnCreation) {
      await this.reload();
    } else {
      this.tableRows = Util.deepCopy(this.rows);
    }

    this.createTableRows();
    this.triggerUpdateFields++;
  }
  // #endregion

  // #region [ METHODS ]
  private getSlotName(col: any): string {
    return `item.${col.value}`;
  }

  private getFieldKey(row: any, column: any): string {
    const rowIndex = Util.indexOf(this.rows, (x: any) => x === row);

    const columnIndex = Util.indexOf(this.columns, (x: any) => x === column);

    const key = `${rowIndex}_${columnIndex}`;
    return key;
  }

  private fieldIsReadOnly(row: any, column: any): boolean {
    const isReadOnly = this.isReadOnly || row.readonly || column.readonly;

    return isReadOnly;
  }

  private fieldOnInput(row: any, column: any) {
    this.$emit('fieldInput', row, column, this.tableRows);
  }

  private edit(row : any) {
    this.setCurrentRow(row);
    this.currentRow['__mode'] = 'edit';
    this.cahangeShowRowPopUp();

    this.triggerUpdateFields++;

    this.$emit('edit', row, this.tableRows);
  }

  private viewMode(row : any) {
    this.setCurrentRow(row);
    this.currentRow['__mode'] = 'view';
    this.cahangeShowRowPopUp();
    this.triggerUpdateFields++;

    //this.$emit('edit', row, this.tableRows);
  }

  private askDelete(row: any){
    this.setCurrentRow(row);
    this.showDialog = true;
  }

  private confirmDelete() {
    const rowIndex = Util.indexOf(this.tableRows,
        (x: any) => x.__id === this.currentRow.__id);

    this.tableRows.splice(rowIndex, 1);

    this.triggerUpdateFields++;

    this.$emit('delete', this.currentRow, this.tableRows);
  }

  private save(row : any) {
    const rowBackup = this.backup.find((x: any) => x.__id === row.__id);
    const rowBackupCopy = Util.deepCopy(rowBackup);

    Object.keys(row).forEach((key) => {
      rowBackupCopy[key] = row[key];
    });

    row.__mode = 'view';
    this.triggerUpdateFields++;

    this.$emit('save', row, this.tableRows);
  }

  private cancel(row : any) {
    const rowBackup = this.backup.find((x : any) => x.__id === row.__id);
    let rowBackupCopy: any;
    if(rowBackup) {
       rowBackupCopy = Util.deepCopy(rowBackup);
      Object.keys(row).forEach((key) => {
        row[key] = rowBackupCopy[key];
      });
    }

    row.__mode = 'view';
    this.triggerUpdateFields++;
    this.$emit('cancel', row, this.tableRows);
  }

  private getCurrentModeActions(row: any): any[] {
    let currentModeAction =
      this.tableActions.filter(x => x.mode === row.__mode);
    if(this.showActionsFunc!=null){
      currentModeAction = currentModeAction.filter(action => this.showActionsFunc(action,row))
    }

    if (row.readonly) {
      currentModeAction = currentModeAction.filter(x => x.readonlyVisible === true);
    }

    // Caso alguma ação tenha a propriedade "condition", essa ação só sera visível
    // se satifazer a condição determinada.
    currentModeAction = currentModeAction.filter((action: any) => {
      if (action.condition) {
        return action.condition(row);
      }

      return true;
    });

    return currentModeAction;
  }

  private createTableRows() {
    this.tableRows.forEach((x: any) => {
      x.__mode = 'view'
      x.__id = this.nextId;

      this.nextId++;
    });

    this.backup = Util.deepCopy(this.tableRows);
  }

  private createTableColumns() {
    this.tableColumns = Util.deepCopy(this.columns);

    this.tableColumns.forEach((column: any) => {
      column.readonly = column.readonly || false;
    });

    const actionsWidth = Math.max(60, this.tableActions.length * 38);

    if (!this.readonly && this.tableActions.length > 0) {
      this.tableColumns.push({
        text: 'Ações',
        value: 'actions',
        align: 'center',
        readonly: true,
        width: actionsWidth,
      });
    }
  }

  private async reload() {
    const params = {
      requestType: 'FilterData',
      ...this.filters,
    };

    try {
      this.tableLoading = true;

      const response = await HttpRequest.get(this.route, params, false);

      const rows =
        response.data.dataset.data ||
        response.data.dataset[this.route] ||
        [];

      Util.redefineArray(this.tableRows, rows);

      this.createTableRows();
      this.tableLoading = false;
      this.insertFooterRow();
      this.$emit('afterReload', this.tableRows);
      this.triggerUpdateFields++;
    } catch(err) {
      this.tableLoading = false;

      SnackbarUtils.showMessage('Não foi possível carregar os dados.', 'error');
    }
  }

  private insertFooterRow() {
    if (this.footerRow) {
      Util.arrayRemoveCondition(this.tableRows,
        (row: any) => row.__footer === true);

      this.footerRow.__footer = true;
      this.footerRow.readonly = true;

      this.tableRows.push(this.footerRow);
    }
  }

  private toolbarActionOnClick(action : any) {
    action.action(this.tableRows);
  }

  private addRow() {
    const newRow = {
      __is_new: true,
      __mode: 'edit',
      ...this.defaultRow,
    };

    const index = this.footerRow ?
      this.tableRows.length - 1 :
      this.tableRows.length;

    this.resetTableRow();
    this.tableRows.splice(index, 0, newRow);
  }

  private addRowPopUp(){
    this.currentRow = {
      __is_new: true,
      __mode: 'edit',
      ...this.defaultRow
    };
    this.cahangeShowRowPopUp();
  }

  private resetTableRow() {
    Util.redefineArray(this.tableRows, this.backup);
  }

  private cellOnClick(row : any, column : any) {
    const readOnly = this.fieldIsReadOnly(row, column);

    if (!readOnly && this.gridEditable ) {
      row.__mode = 'edit';
    }

    this.triggerUpdateFields++;
  }

  private fieldOnEnter(row : any, column : any) {
    if (this.onEnterAction) {
      this.onEnterAction(row, column, this.tableRows);
    } else {
      this.save(row);
    }
  }

  private fieldOnEsc(row : any, column : any) {
    if (this.onEscAction) {
      this.onEscAction(row, column, this.tableRows);
    } else {
      this.cancel(row);
    }
  }

  private onClickAction(action: any) {
    if (action.onClick) {
      action.onClick();
    }
    this.emitClick(action.name);
  }

  private emitClick(event: string) {
    this.$emit(event);
  }

  private showProperties(array: any, property: string){
    let arrayShow: any = [];
    array.forEach((value: any, index: any)=> {
      if(value[property]!==false){
        arrayShow.push(value);
      }
    });
    return arrayShow;
  }

  private setCurrentRow(row: any): void {
    this.currentRow = row;
    this.currentRow['__is_new'] = false;
  }

  private cahangeShowRowPopUp(){
      this.showRowPopUp = !this.showRowPopUp;
  }

  private setBackUpRow(BackUpRow: any){
    this.cancel(this.currentRow);
  }
  // #endregion
}

export default CrudGrid;
